export default [
  {
    path: 'employes/',
    component: () => import('src/pages/employes/Index.vue'),
    children: [
      {
        path: 'list',
        name: 'listEmployes',
        component: () => import('src/pages/employes/List.vue')
      },
      {
        path: 'create',
        name: 'createEmployes',
        component: () => import('src/pages/employes/Create.vue')
      },
      {
        path: 'edit/:id/',
        alias: 'edit/:id',
        name: 'editEmployes',
        component: () => import('src/pages/employes/Edit.vue'),
        redirect: { name: 'adminEmployeBase' },
        children: [
          {
            path: 'base',
            name: 'adminEmployeBase',
            component: () => import('src/pages/employes/components/base.vue')
          },
          {
            path: 'avis',
            name: 'adminEmployeAvis',
            component: () => import('src/pages/employes/components/avis/index.vue')
          },
          {
            path: 'suivis',
            name: 'adminEmployeSuivis',
            props: true,
            component: () => import('src/pages/suivi/List.vue')
          },
          {
            path: 'avis/:typeAvis',
            name: 'adminEmployeAvis',
            component: () => import('src/pages/employes/components/avis/index.vue')
          },
          {
            path: 'horaire',
            name: 'adminEmployeHoraire',
            component: () => import('src/pages/Horaire/index.vue')
          },
          {
            path: 'messagerie',
            name: 'adminEmployeMessagerie',
            component: () => import('src/pages/employes/components/messagerie.vue')
          },
          {
            path: 'avance',
            // eslint-disable-next-line no-secrets/no-secrets
            name: 'adminEmployeChangePassword',
            component: () => import('src/pages/employes/components/avance/index.vue')
          } /*,
          {
            path: 'formations',
            name: 'adminEmployeformations',
            component: () => import('src/pages/employes/components/formations.vue')
          },
          {
            path: 'fichiers',
            name: 'adminEmployefichiers',
            component: () => import('src/pages/employes/components/fichiers.vue')
          }*/
        ]
      },
      {
        path: 'view/:id/',
        name: 'viewEmployes',
        component: () => import('src/pages/employes/View.vue'),
        props: true
      }
    ]
  }
];
